"use client";

import { useRouter } from "next/navigation";
import { Link, MessageCircle } from "lucide-react";

import { useStyles } from "./styles";
import { useAppDispatch } from "@/redux/store";
import { generateAlert } from "@/redux/actions";
import { getDisplayedTimeAgo } from "@/utils/date";
import Avatar from "@/components/common/Avatar";

interface CreatorSummaryProps {
  username: string;
  avatarUrl: string | null;
  onToggleComments: () => void;
  createdAt: string;
}

const CreatorSummary: React.FC<CreatorSummaryProps> = ({
  username,
  avatarUrl,
  onToggleComments,
  createdAt,
}) => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const router = useRouter();

  const handleViewUserProfile = () => {
    router.push(`/profile/${encodeURIComponent(username)}`);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    dispatch(
      generateAlert({
        text: "Copied image thread link to clipboard",
        type: "success",
      })
    );
  };

  return (
    <div className={classes.container}>
      <div className={classes.userDetails} onClick={handleViewUserProfile}>
        <Avatar
          src={avatarUrl || ""}
          alt={username}
          width={26}
          height={26}
          className={classes.userAvatar}
        />
        <div className={classes.userDetailsRight}>
          <p className={classes.username}>{username}</p>
          <div className={classes.userStats}></div>
        </div>
      </div>
      <div className={classes.contentRight}>
        <p className={classes.createdAt}>{getDisplayedTimeAgo(createdAt)}</p>
        <Link
          size={14}
          onClick={handleCopyLink}
          className={classes.iconButton}
        />
        <MessageCircle
          size={14}
          onClick={onToggleComments}
          className={classes.iconButton}
        />
      </div>
    </div>
  );
};

export default CreatorSummary;
